const availablePaymentDays: number[] = [
  ...new Set((new Array(25)).keys())
].map(num => num + 1);

export default availablePaymentDays;
